import React from 'react'

import { FmInformationIcon, Tooltip } from '@octane/spark'

import { Legend } from './StateNotListedTooltip.styled'

export default function StateNotListedTooltip({
    fieldName,
    text,
}: Readonly<{
    fieldName: string
    text: string
}>): JSX.Element {
    return (
        <Legend>
            <Tooltip
                id={`${fieldName}__infoTooltip`}
                showOnHover
                position="top-end"
            >
                <Tooltip.Trigger>
                    <>
                        <span>Don&apos;t see their state?</span>{' '}
                        <FmInformationIcon height={12} width={16} />
                    </>
                </Tooltip.Trigger>
                <Tooltip.Content>
                    <Tooltip.Text>{text}</Tooltip.Text>
                </Tooltip.Content>
            </Tooltip>
        </Legend>
    )
}
